import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-login-failed',
  imports: [RouterLink],
  template: `
    <div class="container py-5 text-center">
      <h2 class="mb-3">No pudimos iniciar tu sesión</h2>
      <p class="text-muted mb-4">
        Ocurrió un problema al iniciar sesión. Por favor, inténtalo de nuevo.
      </p>
      <a routerLink="/" class="btn btn-primary">Volver al inicio</a>
    </div>
  `,
})
export class LoginFailedComponent {}
